import { __awaiter } from "tslib";
import farm from './routers/farm';
import user from './routers/user';
import crop from './routers/crop';
import cycle from './routers/cycle';
import picture from './routers/picture';
import calendar from './routers/calendar';
import { API } from 'aws-amplify';
import { resolve, reject } from './response';
export default {
    farm,
    user,
    crop,
    cycle,
    picture,
    calendar,
    contact({ user, type, files, person, content }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.post('public', `contact`, {
                    body: {
                        user,
                        type,
                        from: 'console',
                        files,
                        person,
                        content
                    }
                });
                return resolve(result);
            }
            catch (e) {
                throw reject(e);
            }
        });
    },
    config() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.get('public', `config`, {});
                return resolve(result);
            }
            catch (e) {
                throw reject(e);
            }
        });
    }
};
